module.exports = __webpack_public_path__ + "static/media/favicon-32x32.4ccfb3a5.svg";